// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2zbis","gfeWrapper":"CalendarEvent_gfeWrapper___Z1O1"};